import { render, staticRenderFns } from "./BotaoEnviarProposta.vue?vue&type=template&id=6d71a0ab&scoped=true"
import script from "./BotaoEnviarProposta.vue?vue&type=script&lang=js"
export * from "./BotaoEnviarProposta.vue?vue&type=script&lang=js"
import style0 from "./BotaoEnviarProposta.vue?vue&type=style&index=0&id=6d71a0ab&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71a0ab",
  null
  
)

export default component.exports